import Vue from "vue";
import Vuex from "vuex";

import modules from "./modules";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules,
  // Enable strict mode in development to get a warning
  // when mutating state outside of a mutation.
  // https://vuex.vuejs.org/guide/strict.html
  // strict: process.env.NODE_ENV !== 'production',
  state: {
    loggedInUserId: null, // State untuk menyimpan ID user yang login
  },
  mutations: {
    setUserId(state, userId) {
      state.loggedInUserId = userId;
    },
  },
  actions: {
    loginUser({ commit }, userId) {
      commit("setUserId", userId); // Simpan ID user saat login
    },
    logoutUser({ commit }) {
      commit("setUserId", null); // Hapus ID user saat logout
    },
  },
  getters: {
    getLoggedInUserId(state) {
      return state.loggedInUserId;
    },
  },
});

export default store;
